import { withAppCrashIfException } from 'epic';
import { combineEpics } from 'redux-observable';

import { fetchProductDescriptionsEpic } from './fetchProductDescriptionsEpic';

export const productDescriptionsEpic = () =>
  combineEpics(withAppCrashIfException('fetchProductDescriptionsEpic', fetchProductDescriptionsEpic()));
